import { connect } from 'react-redux';
import { fetchOrgSurveysCompareRadarChartData, showOrgSurveyLoader } from 'actions/OrgSurvey';
import Component from './Component';


export const mapStateToProps = ({ orgSurveys }) => {
    const {
        orgSurveyCompareList,
        orgSurveyCompareRadarChartData
    } = orgSurveys;
    return {
        orgSurveyCompareList,
        orgSurveyCompareRadarChartData
    };
};
export default connect(mapStateToProps, {
    showOrgSurveyLoader,
    fetchOrgSurveysCompareRadarChartData
})(Component);


// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Container.js